import Alert from '@mui/material/Alert';
import Skeleton from '@mui/material/Skeleton';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { useValidation, VerificationCard } from '../../validation';
import { SettingsQueryGate } from '../components/SettingsQueryGate';

export function VerificationSettingsPage(): ReactElement {
    const { t } = useTranslation();
    const validationQuery = useValidation();

    return (
        <SettingsQueryGate query={validationQuery} loading={<Skeleton variant="rounded" height={480} />}>
            {({ validation }) =>
                validation ? (
                    <VerificationCard validation={validation} />
                ) : (
                    // Partner Management opens the validation, so there is nothing for the craftsman to do until it exists.
                    <Alert severity="info">{t('SETTINGS.VERIFICATION.NOT_STARTED')}</Alert>
                )
            }
        </SettingsQueryGate>
    );
}
